import moment from 'moment';
import { ReferentDto } from '../../dto/referent.dto';

export class RsjDto {
  public id: number;
  public beneficiaryId: number;
  public rsjState: number;
  public beginDateRsj: Date;
  public endDateRsj: Date;
  public rsjCloseReason: number;
  public currentReferent: ReferentDto;
  public remainingPayment: number;

  public static fromJson(json: any): RsjDto {
    if (json) {
      return {
        id: json.id,
        beneficiaryId: json.beneficiaryId,
        rsjState: json.rsjState,
        beginDateRsj: json.beginDateRsj ? moment(json.beginDateRsj).toDate() : undefined,
        endDateRsj: json.endDateRsj ? moment(json.endDateRsj).toDate() : undefined,
        rsjCloseReason: json.rsjCloseReason,
        currentReferent: ReferentDto.fromJson(json.currentReferent),
        remainingPayment: json.remainingPayment,
      } as RsjDto;
    }
  }
}
